<template>
  <div id="CargosStep">
    <v-card elevation="1" class="pa-1 pt-0">
      <div class="d-flex pa-2 pt-1 list-container">
        <v-card class="column pa-1">
          <div class="d-flex justify-space-between align-center column-title px-3">
            <div class="d-flex align-center">
              <h1 style="color: black">Paradas</h1>
              <v-divider v-show="!isCollapsed" vertical class="mx-2 my-1"></v-divider>
              <span v-show="!isCollapsed" class="mb-0 mt-1 font-weight-medium caption mr-2"
                >{{ filteredUnallocatedStops.length }} itens</span
              >
              <v-tooltip right nudge-top="1">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-checkbox
                      v-if="!isCollapsed"
                      v-model="selectAllStops"
                      :disabled="filteredUnallocatedStops.length === 0"
                      class="custom-checkbox pa-0 ma-0"
                      hide-details
                      @change="toggleSelectAllStops"
                    ></v-checkbox>
                  </div>
                </template>
                <span>Selecionar todas</span>
              </v-tooltip>
            </div>
            <div class="d-flex align-center">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="dataErrors.length > 0"
                    v-bind="attrs"
                    v-on="on"
                    class="mr-1"
                    color="red"
                    icon
                    small
                    dark
                    @click="OpenDeliveryDetails()"
                  >
                    <v-icon size="22" v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalhes dos erros</span>
              </v-tooltip>
              <span v-if="filteredUnallocatedStops.length > 0">
                <v-tooltip v-if="!isCollapsed" right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="isCollapsed = !isCollapsed"
                      >mdi-chevron-double-left</v-icon
                    >
                  </template>
                  <span>Recolher</span>
                </v-tooltip>
                <v-tooltip v-else right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="isCollapsed = !isCollapsed">
                      mdi-chevron-double-right
                    </v-icon>
                  </template>
                  <span>Expandir</span>
                </v-tooltip>
              </span>
            </div>
          </div>
          <div v-if="isCollapsed" class="d-flex justify-space-between align-center px-3">
            <v-checkbox
              v-model="selectAllStops"
              label="Selecionar todas"
              :disabled="filteredUnallocatedStops.length === 0"
              class="custom-checkbox collapsed pa-0 ma-0"
              hide-details
              @change="toggleSelectAllStops"
            ></v-checkbox>
            <v-divider vertical class="mx-1 my-1"></v-divider>
            <span class="mb-0 font-weight-medium caption">{{ filteredUnallocatedStops.length }} itens</span>
          </div>
          <v-divider class="mx-2 my-1"></v-divider>
          <v-text-field
            v-show="!isCollapsed"
            class="custom-search px-2"
            label="Buscar"
            color="black"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            single-line
            v-model="searchQueryUnallocated"
            @keydown.enter="performSearch('unallocated')"
            @click:prepend-inner="performSearch('unallocated')"
          ></v-text-field>
          <div v-if="isUnallocatedLoading" class="px-2">
            <v-progress-linear indeterminate />
          </div>
          <div
            class="deliveries-container pa-2 pt-0 justify-center"
            :style="{ height: isCollapsed ? '540px' : '530px', width: isCollapsed ? '240px' : '370px' }"
          >
            <drag-card-stops
              :stops="filteredUnallocatedStops"
              :selectedStop="selectedStops"
              :isCollapsed="isCollapsed"
              @update:selected="updateStopSelection"
              @update:selectedDeliveries="selectedStops = $event"
              @update:selectAll="selectAllStops = $event"
            />
          </div>
        </v-card>
        <div class="w-100 column pa-1">
          <div class="d-flex justify-space-between align-center column-title px-3">
            <div class="d-flex align-center">
              <h1 style="color: black">Cargas</h1>
              <v-divider vertical class="mx-2 my-1"></v-divider>
              <v-label class="pb-0 pt-1 mr-2 font-weight-medium black--text" style="font-size: 14px"
                >{{ filteredCargos.length }} itens</v-label
              >
              <v-checkbox
                v-model="selectAllCargos"
                label="Selecionar todas"
                :disabled="filteredCargos.length === 0"
                class="custom-checkbox collapsed pa-0 ma-0 mt-1"
                hide-details
                @change="toggleSelectAllCargos"
              />
            </div>
          </div>
          <v-divider class="mx-2 my-1"></v-divider>
          <v-text-field
            v-show="cargos.length > 0"
            class="custom-search px-2"
            label="Buscar"
            color="black"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            single-line
            v-model="searchQueryCargos"
            @keydown.enter="performSearch('cargos')"
            @click:prepend-inner="performSearch('cargos')"
          ></v-text-field>
          <div v-if="isStopsLoading" class="px-2">
            <v-progress-linear indeterminate />
          </div>
          <div v-if="!cargos.length > 0" class="selected-container d-flex align-center justify-center rounded mb-2">
            <v-icon size="60" color="" style="padding-bottom: 3px">mdi-emoticon-neutral-outline</v-icon>
            <div class="d-flex flex-column ml-2">
              <span class="text-h5">Nenhuma carga criada até o momento.</span>
              <span class="text-subtitle-1 font-weight-regular">
                Crie uma
                <a
                  class="new-import-delivery text-decoration-underline"
                  target="_blank"
                  rel="noopener noreferrer"
                  @click="$emit('isDialogFormOpen', true)"
                  >nova carga</a
                >
                para prosseguir.
              </span>
            </div>
          </div>
          <div class="d-flex justify-center align-center py-3" v-else-if="filteredCargos.length == 0">
            Nenhuma parada encontrada
          </div>
          <div class="stop-container" v-else>
            <CargoHierarchy
              ref="CargoHierarchy"
              v-for="item in virtualCargosList"
              :cargo="item"
              :selected="selectedCargos[item.id]"
              :key="item.id"
              @update:selected="updateCargoSelection"
              @update:selectAll="selectAllCargos = $event"
              @input="item.alocatedDeliveries = $event"
              @update:allocated="updateUnallocated"
              @removeCargo="removeCargo(item.id)"
            />
            <div v-if="filteredCargos.length" v-observe-visibility="handleCargosScroll"></div>
          </div>
          <div class="px-2 mt-2"></div>
        </div>
      </div>
    </v-card>
    <confirm-dialog
      :isOpen="isOpenConfirmationComputed || isOpenConfirmDeleteComputed"
      @confirmClick="confirmClick"
      :title="titleConfirmation"
      @cancelClick="cancel"
      :body-text="bodyText"
    />
    <errors-details-dialog
      :isOpen="isOpenDeliveryDetails"
      :dataErrors="dataErrors"
      @confirmClick="confirmClick"
      @cancelClick="isOpenDeliveryDetails = false"
    />
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import DragCardStops from '@/components/ManualBoardingImport/Stepper/Step5/DragCardStops.vue';
import CargoHierarchy from '@/components/ManualBoardingImport/Stepper/Step5/CargoHierarchy.vue';
import ErrorsDetailsDialog from '@/components/ManualBoardingImport/Stepper/Step5/ErrorsDetailsDialog.vue';
import ConfirmDialog from '@/components/ConfirmDialog';
import MessagesError from '@/components/MessagesError.vue';
import { mapActions } from 'vuex';
import maskWeight from '@/utils/maskWeight';
import maskCPF from '@/utils/maskCPF';
import maskCNPJ from '@/utils/maskCNPJ';
export default {
  name: 'CargosStep',
  components: {
    DragCardStops,
    CargoHierarchy,
    ConfirmDialog,
    ErrorsDetailsDialog,
    MessagesError
  },
  props: {
    isOpenConfirmation: {
      type: Boolean,
      default: false
    },
    isOpenConfirmDelete: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isUnallocatedLoading: false,
    isOpenDeliveryDetails: false,
    isStopsLoading: false,
    unallocatedStops: [],
    cargos: [],
    dataErrors: [],
    cargosToShow: 5,
    filteredUnallocatedStops: [],
    filteredCargos: [],
    selectAllStops: false,
    selectAllCargos: false,
    selectedStops: {},
    selectedCargos: {},
    searchQueryUnallocated: '',
    searchQueryCargos: '',
    isCollapsed: true,
    errors: [],
    errorsType: 'error',
    error500: null
  }),
  mounted() {
    this.fetchUnallocatedStops();
    this.fetchCargos();
  },
  watch: {
    cargos: {
      handler() {
        this.checkAndEmit();
      }
    },
    unallocatedStops: {
      handler() {
        this.checkAndEmit();
      }
    },
    filteredUnallocatedStops: {
      handler() {
        this.selectAllStops ? this.toggleSelectAllStops() : this.updateSelectAllStops();
      }
    },
    filteredCargos: {
      handler() {
        this.selectAllCargos ? this.toggleSelectAllCargos() : this.updateSelectAllCargos();
      }
    },
    searchQueryUnallocated: {
      handler(value) {
        if (value === '') {
          this.filteredUnallocatedStops = this.unallocatedStops;
        }
      }
    },
    searchQueryCargos: {
      handler(value) {
        if (value === '') {
          this.filteredCargos = this.cargos;
        }
      }
    },
    selectedCargos: {
      handler() {
        this.$emit('selectedCargosIds', this.selectedCargosIds);
      }
    }
  },
  computed: {
    parameterID() {
      return this.$route.params.id;
    },
    isOpenConfirmationComputed: {
      get() {
        return this.isOpenConfirmation;
      },
      set(value) {
        this.$emit('update:isOpenConfirmation', value);
      }
    },
    isOpenConfirmDeleteComputed: {
      get() {
        return this.isOpenConfirmDelete;
      },
      set(value) {
        this.$emit('update:isOpenConfirmDelete', value);
      }
    },
    selectedStopsIds() {
      return Object.keys(this.selectedStops).filter((id) => this.selectedStops[id]);
    },
    selectedCargosIds() {
      return Object.keys(this.selectedCargos).filter((id) => this.selectedCargos[id]);
    },
    virtualCargosList() {
      return this.filteredCargos.slice(0, this.cargosToShow);
    },
    titleConfirmation() {
      if (this.isOpenConfirmDeleteComputed) {
        return 'Desfazer Cargas';
      } else {
        return 'Confirmar carga(s) criadas';
      }
    },
    bodyText() {
      if (this.isOpenConfirmDeleteComputed) {
        const selectedCargos = this.cargos.filter((cte) => this.selectedCargosIds.includes(cte.id));
        const numbers = selectedCargos.map((cargo) => cargo.cargoNumber);
        return `Confirmar desalocar as paradas relacionadas e o descarte das cargas:${numbers.slice(0, 15)}${
          numbers.length > 15 ? '...' : ''
        }?`;
      } else {
        return `Você confirma os dados das ${this.cargos.length} carga(s)?`;
      }
    }
  },
  methods: {
    ...mapActions('ImportManualCargosStore', [
      'getAllUnallocatedStops',
      'getAllCargos',
      'createNewCargo',
      'createGroupedCargos',
      'deleteCargo',
      'deleteMultipleCargos'
    ]),

    async fetchUnallocatedStops() {
      try {
        this.isUnallocatedLoading = true;
        const data = await this.getAllUnallocatedStops(this.parameterID);
        this.unallocatedStops = data.map((stop) => ({
          ...stop,
          error: null,
          transshipments: null
        }));
        if (this.dataErrors && this.dataErrors.length > 0) {
          this.dataErrors = this.dataErrors.filter((error) =>
            error.stopNumber.some((stopNumber) => this.unallocatedStops.some((stop) => stop.stopNumber === stopNumber))
          );
          this.dataErrors.forEach((error) => {
            if (error.stopNumber && error.stopNumber.length > 0) {
              error.stopNumber.forEach((stopNumber) => {
                const stopWithError = this.unallocatedStops.find((stop) => stop.stopNumber === stopNumber);
                if (stopWithError) {
                  stopWithError.error = error.error;
                  stopWithError.transshipments = error.transshipments;
                }
              });
            }
          });
        }
        this.filteredUnallocatedStops = this.unallocatedStops;
        await this.filterStops();
      } catch (err) {
        console.error(err);
      } finally {
        this.isUnallocatedLoading = false;
      }
    },
    async fetchCargos() {
      try {
        this.isStopsLoading = true;
        const data = await this.getAllCargos(this.parameterID);
        this.cargos = data;
        this.filteredCargos = data;
        await this.filterCargos();
      } catch (err) {
        console.error(err);
      } finally {
        this.isStopsLoading = false;
      }
    },
    async addCargo(isGrouped, value) {
      this.$emit('isCreateStopLoading', true);
      try {
        const model = {
          processId: this.parameterID,
          ...value
        };
        isGrouped ? await this.automaticGroupedStops(model) : await this.createNewCargo(model);
        this.fetchCargos();
      } catch (err) {
        console.error(err);
      } finally {
        this.$emit('isCreateStopLoading', false);
      }
    },
    async automaticGroupedStops(model) {
      this.$emit('isAutomaticGroupedLoading', true);
      let totalUnallocatedStops = this.unallocatedStops.length;
      try {
        model = {
          ...model,
          stopsIds: this.selectedStopsIds
        };
        const response = await this.createGroupedCargos(model);
        if (response.success) {
          this.errors = ['Agrupamento realizado com sucesso!'];
          this.errorsType = 'success';
        } else {
          await this.fetchUnallocatedStops();
          let parsedErrors = [];
          let errorsCount = 0;
          try {
            parsedErrors = JSON.parse(response.errors).map((error) => {
              const errorMessage = error.Error.match(/(.*?)(Transbordos:\s*)(.*)/);
              return {
                ...error,
                stopNumber: error.StopNumbers || [], // Default to empty array if StopNumbers are missing
                error: errorMessage ? errorMessage[1].trim() : error.Error,
                transshipments: errorMessage && errorMessage[3] ? errorMessage[3].trim() : ''
              };
            });
            this.dataErrors = parsedErrors;
          } catch (e) {
            parsedErrors = response.errors || ['Erro desconhecido ao agrupar cargas'];
          }

          parsedErrors.forEach((error) => {
            if (error.StopNumbers) {
              error.StopNumbers.forEach((stopNumber) => {
                const stopWithError = this.unallocatedStops.find((stop) => stop.stopNumber === stopNumber);
                if (stopWithError) {
                  errorsCount++;
                  stopWithError.error = error.error;
                  stopWithError.transshipments = error.transshipments;
                }
              });
            }
          });
          this.errors =
            errorsCount > 0
              ? totalUnallocatedStops == errorsCount
                ? [`Não foi possível agrupar nenhuma das ${errorsCount} paradas.`]
                : [
                    `${errorsCount} paradas não foram agrupadas devido a erros no transbordo ou por serem entregas diretas.`
                  ]
              : ['Erro ao Agrupar Cargas'];
          this.errorsType = 'error';
        }
        this.fetchCargos(false);
        this.checkAndEmit();
      } catch (error) {
        this.errors = ['Erro na comunicação com o servidor'];
        this.errorsType = 'error';
      } finally {
        this.$emit('isAutomaticGroupedLoading', false);
      }
    },
    async removeCargo(id = null, multi = false) {
      try {
        const response = multi ? await this.deleteMultipleCargos(this.selectedCargosIds) : await this.deleteCargo(id);
        if (response.success) {
          this.errors = [`${multi ? 'Cargas deletadas' : 'Carga deletada'} com sucesso!`];
          this.errorsType = 'success';
          this.selectedCargos = {};
        } else {
          this.errors = response.errors || ['Erro ao deletar Carga(s)'];
          this.errorsType = 'error';
        }
        this.fetchUnallocatedStops();
        this.fetchCargos(false);
        setTimeout(() => {
          this.checkAndEmit();
        }, 100);
      } catch (err) {
        console.error(err);
      } finally {
        this.isUnallocatedLoading = false;
      }
    },
    toggleSelectAllStops() {
      this.selectedStops = {};
      this.filteredUnallocatedStops.forEach((delivery) => {
        this.$set(this.selectedStops, delivery.id, this.selectAllStops);
      });

      this.updateSelectAllStops();
    },
    updateStopSelection(id) {
      this.$set(this.selectedStops, id, !this.selectedStops[id]);
      this.updateSelectAllStops();
    },
    updateSelectAllStops() {
      this.selectAllStops =
        this.filteredUnallocatedStops.length > 0
          ? this.filteredUnallocatedStops.every((delivery) => this.selectedStops[delivery.id])
          : false;
      this.checkAndEmit();
    },
    toggleSelectAllCargos() {
      this.selectedCargos = {};
      this.filteredCargos.forEach((cargo) => {
        this.$set(this.selectedCargos, cargo.id, this.selectAllCargos);
      });
      this.updateSelectAllCargos();
    },
    updateSelectAllCargos() {
      this.selectAllCargos =
        this.filteredCargos.length > 0 ? this.filteredCargos.every((cargo) => this.selectedCargos[cargo.id]) : false;
      this.$emit('selectedCargosIds', this.selectedCargosIds);
      this.checkAndEmit();
    },
    updateCargoSelection(id) {
      this.$set(this.selectedCargos, id, !this.selectedCargos[id]);
      this.updateSelectAllCargos();
    },
    performSearch(type) {
      if (type === 'unallocated') {
        this.filterStops();
      } else if (type === 'cargos') {
        this.filterCargos();
      }
    },
    filterStops() {
      const query = this.searchQueryUnallocated ? this.searchQueryUnallocated.toLowerCase() : '';
      const queryNormalized = query.replace(/[^\d]/g, '');
      if (query === '') {
        this.filteredUnallocatedStops = this.unallocatedStops;
      } else {
        const normalizeValue = (value) => (value ? value.replace(/[^\d]/g, '') : '');
        this.filteredUnallocatedStops = this.unallocatedStops.filter((stop) => {
          return (
            (stop.stopNumber && stop.stopNumber.toString().toLowerCase().includes(query)) ||
            (stop.nameCityRecipient && stop.nameCityRecipient.toLowerCase().includes(query)) ||
            (stop.nameRecipient && stop.nameRecipient.toLowerCase().includes(query)) ||
            (stop.amountDeliveries && stop.amountDeliveries.toString().toLowerCase().includes(query)) ||
            (stop.totalPriceNfes && normalizeValue(maskWeight(stop.totalPriceNfes)).includes(queryNormalized)) || // Normalized price check
            (stop?.weightDeliveries && `${maskWeight(stop?.weightDeliveries || 0)}kg`.toLowerCase().includes(query))
          );
        });
      }
    },
    filterCargos() {
      const query = this.searchQueryCargos ? this.searchQueryCargos.toLowerCase() : '';
      const queryNormalized = query.replace(/[^\d]/g, '');
      if (query == null) {
        this.filteredCargos = this.cargos;
      } else {
        this.filteredCargos = this.cargos.filter((cargo) => {
          const isPartialEntregaDireta = 'entrega direta'.includes(query) && cargo.transhipmentName === null;
          const isPartialTransbordo = 'transbordo'.includes(query) && cargo.transhipmentName !== null;
          const normalizeValue = (value) => (value ? value.replace(/[^\d]/g, '') : '');

          return (
            isPartialEntregaDireta ||
            isPartialTransbordo ||
            (cargo.cargoNumber && cargo.cargoNumber.toString().toLowerCase().includes(query)) ||
            (cargo.transhipmentName && cargo.transhipmentName.toLowerCase().includes(query)) ||
            (cargo.transhipmentCity && cargo.transhipmentCity.toLowerCase().includes(query)) ||
            (cargo.totalTranshipmentPrice &&
              normalizeValue(maskWeight(cargo.totalTranshipmentPrice)).includes(queryNormalized)) ||
            (cargo.totalPriceNfes && normalizeValue(maskWeight(cargo.totalPriceNfes)).includes(queryNormalized)) ||
            (cargo.weightDeliveries && `${maskWeight(cargo.weightDeliveries)}kg`.toLowerCase().includes(query)) ||
            (cargo.amountStops && cargo.amountStops.toString().toLowerCase().includes(query))
          );
        });
      }
    },
    cancel() {
      this.isOpenConfirmationComputed = false;
      this.isOpenConfirmDeleteComputed = false;
    },
    confirmClick() {
      if (this.isOpenConfirmDeleteComputed) {
        this.removeCargo(null, this.selectedStopsIds);
        this.isOpenConfirmDeleteComputed = false;
      } else {
        this.$emit('confirmClick');
      }
    },
    checkAndEmit() {
      const hasStops = this.cargos.length > 0;
      const hasStopsWithDeliveries = this.cargos.some((cte) => cte.amountStops > 0);
      const hasStopsWithoutDeliveries = this.cargos.filter((cte) => cte.amountStops == 0);
      let message = '';
      let errorValidate = false;
      if (!hasStops) {
        message = 'Crie pelo menos uma carga';
        errorValidate = true;
      } else if (!hasStopsWithDeliveries) {
        message = 'Nenhuma carga com paradas alocadas';
        errorValidate = true;
      } else if (hasStopsWithoutDeliveries.length > 0) {
        const numbers = hasStopsWithoutDeliveries.map((delivery) => delivery.cargoNumber).join(', ');
        message = `Carga(s) de N° ${numbers} devem ter ao menos uma parada alocada`;
        errorValidate = true;
      }
      this.$emit('step4Finished', errorValidate, message);

      message = '';
      errorValidate = false;
      if (this.unallocatedStops.length === 0) {
        message = 'Nenhuma carga disponível para agrupamento';
        errorValidate = true;
      } else if (this.selectedStopsIds.length === 0) {
        message = 'Selecione as cargas para agrupar';
        errorValidate = true;
      }
      this.$emit('isDisabledAutomaticGrouped', message, errorValidate);
    },
    OpenDeliveryDetails() {
      this.isOpenDeliveryDetails = true;
    },
    handleCargosScroll(isVisible) {
      if (!isVisible || this.cargosToShow >= this.filteredCargos.length) return;
      this.cargosToShow += 5;
    },
    async updateUnallocated(response, success) {
      if (success) {
        this.errors = [response];
        this.errorsType = 'success';
        this.selectedStops = {};
        this.selectAllStops = false;
      } else {
        this.errors = ['Não foi possível agrupar. Por favor, verifique os erros'];
        let parsedErrors = JSON.parse(response).map((error) => {
          const errorMessage = error.Error.match(/(.*?)(Transbordos:\s*)(.*)/);
          return {
            ...error,
            stopNumber: error.StopNumbers || [],
            error: errorMessage ? errorMessage[1].trim() : error.Error,
            transshipments: errorMessage && errorMessage[3] ? errorMessage[3].trim() : ''
          };
        });
        this.dataErrors = parsedErrors;

        parsedErrors.forEach((error) => {
          if (error.StopNumbers) {
            error.StopNumbers.forEach((stopNumber) => {
              const stopWithError = this.unallocatedStops.find((stop) => stop.stopNumber === stopNumber);
              if (stopWithError) {
                stopWithError.error = error.error;
                stopWithError.transshipments = error.transshipments;
              }
            });
          }
        });
        this.errorsType = 'info';
      }

      await this.fetchUnallocatedStops();
      if (this.unallocatedStops.length === 0) {
        this.isCollapsed = true;
      }
      await this.fetchCargos();
      this.checkAndEmit();
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }

      return maskCNPJ(str);
    }
  }
};
</script>
<style lang="scss" scoped>
.list-container {
  width: 100%;
  height: 638px;
}
.selected-container {
  width: 100%;
  height: 520px;
}
.card-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
}
.stop-container {
  width: 100%;
  height: auto;
  max-height: 540px;
  overflow-y: auto;
  overflow-x: hidden;
}
.selected-card {
  box-shadow: 0 2px 4px rgba(23, 23, 23, 0.18);
  border: solid 1px #4299e1;
  color: #4299e1;
  h4,
  .v-icon path {
    color: #4299e1;
    fill: #4299e1;
  }
}
.column-title {
  width: 100%;
  text-align: left;
}

.deliveries-container {
  width: 100%;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
}
.deliveries-container::-webkit-scrollbar,
.stop-container::-webkit-scrollbar {
  width: 8px;
  height: 5px;
  background-color: #f5f5f5;
}

.deliveries-container::-webkit-scrollbar-track,
.stop-container::-webkit-scrollbar-track {
  padding-left: 1px;
  padding-right: 1px;
  background-color: #f5f5f5;
}

.deliveries-container::-webkit-scrollbar-thumb,
.stop-container::-webkit-scrollbar-thumb {
  background-color: #999999;
  border-radius: 8px;
}
.deliveries-container::-webkit-scrollbar-thumb:hover,
.stop-container::-webkit-scrollbar-thumb:hover {
  background-color: #0f426e9d;
}
.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
.icon {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
.new-import-delivery {
  color: #4299e1;
}
::v-deep .custom-checkbox .v-label {
  font-weight: 500;
  font-size: 14px;
  color: black;
}
::v-deep .v-input {
  input {
    max-height: 40px;
    .v-input__slot .v-input__prepend-inner {
      position: relative;
      top: 0px;
    }
  }
  .v-text-field {
    &__slot {
      margin: 0;
      padding: 0;

      input,
      textarea {
        border: none;
        border-radius: none;
        padding: 0 0px;
        box-shadow: none;
        background: none;

        &:focus,
        &:hover {
          background: none;
          border-color: none;
        }
      }

      .v-label {
        position: relative;
        transform: translateY(0px);
        top: auto;
        color: black;
      }
    }
  }
}

::v-deep .custom-checkbox .collapsed .v-input--selection-controls__input {
  margin-right: 0px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
